import { useState } from 'react';
import { Grid, Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useIntl } from 'react-intl';

const AccordionQA = () => {
	const {
		messages: { accordionQAs },
	} = useIntl();
	const [expanded, setExpanded] = useState(1);

	const handleChange = panel => (_, newExpanded) => {
		setExpanded(newExpanded ? panel : false);
	};

	return (
		<Grid>
			{accordionQAs?.map(({ id, question, answer }) => (
				<Accordion
					key={id}
					defaultExpanded={id === 1}
					sx={{
						border: `2px solid rgba(255, 191, 63)`,
						bgcolor: '#FFEFD0',
						boxShadow: 'none',
					}}
					expanded={expanded === id}
					onChange={handleChange(id)}
				>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel1-content"
						id="panel1-header"
					>
						<Typography fontSize={'18px'}> {question} </Typography>
					</AccordionSummary>
					<AccordionDetails>
						<Typography fontSize={'16px'}> {answer} </Typography>
					</AccordionDetails>
				</Accordion>
			))}
		</Grid>
	);
};

export default AccordionQA;
